import * as React from 'react';

import Collapse from 'antd/lib/collapse';

import MiddleText from '@app/components/UI/MiddleText/MiddleText';
import {AreaAdditionalServiceWebsite} from '@app/objects/AreaService';

const {Panel} = Collapse;

const carrotIcon = require('@app/images/carrot.png');

interface AreaServicesCommonInfoProps {
	additionalServices?: AreaAdditionalServiceWebsite[];
	customReplacements?: AreaAdditionalServiceWebsite[];
}

const AreaServicesCommonInfo: React.FC<AreaServicesCommonInfoProps> = ({additionalServices, customReplacements}) => {
	const [combinedServices, setCombinedServices] = React.useState<AreaAdditionalServiceWebsite[]>();

	React.useEffect(() => {
		const services = additionalServices?.slice();

		if (customReplacements && customReplacements.length && services) {
			customReplacements.forEach((replacement) => {
				const index = services.findIndex(service => service.name?.toUpperCase() === replacement.name?.toUpperCase());

				if (index >= 0) {
					services[index] = { name: services[index].name, description: replacement.description };
				}
			});
		}

		setCombinedServices(services);
	}, [additionalServices, customReplacements]);

	return (
		<div className="area-common-info">
			<section className="area__section">
				<Collapse
					className="area-services-collapse"
					bordered={false}
					defaultActiveKey={['0', '1', '2']}
					expandIcon={() => <img className="carrot-icon" src={carrotIcon} alt="" />}
					expandIconPosition="right"
				>
					{combinedServices?.map((question, index: number) => (
						<Panel key={index} header={question.name}>
							<div dangerouslySetInnerHTML={{__html: question.description || ''}} />
						</Panel>
					))}
				</Collapse>
			</section>
		</div>
	);
};

export default AreaServicesCommonInfo;
